import {observer} from "mobx-react";
import {ReactNode} from "react";
import {createKeyedStoreContext} from "./createKeyedStoreContext";
import {CustomerStore} from "../store/CustomerStore";
import "./LabeledText.scss"
import "./Widget.scss"
import {useNavigate} from "react-router";


interface CustomerProviderProps {
    customerId: string | undefined
    children: ReactNode
}

const {
    Provider: BaseCustomerStoreProvider,
    useStore: useCustomerStore
} = createKeyedStoreContext<CustomerStore, CustomerProviderProps>({
    displayName: "Customer",
    getKey: ({customerId}) => {
        return customerId ?
            `${customerId ?? ""}` :
            'invalid'
    },
    createStore: ({customerId}) => {
        return customerId ? new CustomerStore(customerId) : new CustomerStore(undefined)
    }
})

const CustomerProvider = observer(BaseCustomerStoreProvider)

interface CustomerProps {
    customerId: string | undefined
}

const WidgetHeader = observer(function WidgetHeader() {
    const navigate = useNavigate()
    const store = useCustomerStore()
    return <div className={'card-header'}>
        <span className={'card-header-title'}>Kundeninfo</span>
        {store.loading && <span className={'card-header-icon'}>
            <button className={'button is-ghost is-loading'}></button>
        </span>}
        {!store.loading && <button className={'card-header-icon'} onClick={() => {
            if(store.customerId) {
                navigate(`/cms/${store.customerId}`)
            }
        }}>
            <span className="material-symbols-outlined">business_center</span>
        </button>}
    </div>
})

interface LabeledTextProps {
    label: string
    text: string
}
function LabeledText({
    label,
    text,
                     }: LabeledTextProps) {
    return <>
        <div className={'cmp-labeled-text'}>
            <label className={'label'}>{label}</label>
            <div className={'control'}>{text}</div>
        </div>
    </>
}

const WidgetContent = observer(function WidgetContent() {
    const store = useCustomerStore()
    const isConfigured = Boolean(store.customerId)

    return <>
        <div className={'card-content'} style={{minHeight: '7.2em'}}>
            {!isConfigured && <>Warte auf Kunde</>}
            {isConfigured && !store.loading && !store.data && <div>
                Keine Daten gefunden
            </div>}
            {isConfigured && !store.loading && store.data && <>
                <div className={'columns'} style={{flex: 1}}>
                    <div className={'column is-one-third'}>
                        <LabeledText label={'Name'} text={store.data?.data.name || ''} />
                    </div>
                    <div className={'column is-one-third'}>
                        <LabeledText label={'Kundennummer (SAP)'} text={store.data?.data.customerNumber || ''} />
                    </div>
                    <div className={'column is-one-third'}>
                        <LabeledText label={'Anzeigename'} text={store.data?.data.displayName || ''} />
                    </div>
                </div>
            </>}
        </div>
    </>
})

const CustomerWidget = observer(function CustomerWidget({
                                                            customerId,
                                                        }: CustomerProps) {

    return <CustomerProvider customerId={customerId}>
        <div className={'card widget'}>
            <WidgetHeader/>
            <WidgetContent/>
        </div>
    </CustomerProvider>
});

export {
    CustomerWidget
}
